<template>
  <div class="element-wrapper">
        <div class="element-box-tp">
          <div class="col text-center" v-if="tableData.length == 0">
              <h5>Não há Profissionais registrados para essa unidade.</h5>
          </div>
          <div v-else class="row">
            <div class="col-md-6"
              v-for="profissional in tableData" :key="profissional._id">
              <div class="element-box el-tablo profile-tile-box">
                <div class="row justify-content-center">

                  <div class="col-sm-4 col-4">
                    <div class="text-center user-avatar">
                      <imagem-profissional style="width: 100px; heigth: 100px" :idProfissional="profissional._id"></imagem-profissional>
                    </div>
                    <p class="text-center"><strong>{{ profissional.nome }}</strong></p>
                    <p class="text-center"><span class="smaller lighter">{{ profissional.tipoRegistro}} - {{ profissional.numeroRegistro }}</span></p>
                    <p class="text-center"><span class="smaller lighter"> {{ profissional.especialidade.nome }}</span></p>
                  </div>
                  <div class="col">
                    <div class="label">
                      <span class="smaller lighter">Sobre</span>
                    </div>
                    <h6>{{profissional.miniBio}}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import ImagemProfissional from '@/components/shared/ImagemProfissional'

export default {
  components: {
    ImagemProfissional
  },
  computed: {
    tableData () {
      return this.$store.getters.profissionais
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/single-consultorio/ProfissionaisTab.vue